package com.bulut.mecitogullari.ui.screens.dashboard

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.bulut.mecitogullari.core.session.SessionManager
import com.bulut.mecitogullari.core.tenant.CompanyProfile
import com.bulut.mecitogullari.core.util.YearMonth
import com.bulut.mecitogullari.core.util.currentYearMonth
import com.bulut.mecitogullari.data.model.CashTransaction
import com.bulut.mecitogullari.data.model.MonthSummary
import com.bulut.mecitogullari.data.model.computeMonthSummary
import com.bulut.mecitogullari.data.model.inMonth
import com.bulut.mecitogullari.data.model.ledgerOnly
import com.bulut.mecitogullari.data.repository.ProjectRepository
import com.bulut.mecitogullari.data.repository.TransactionRepository
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.stateIn

data class DashboardUiState(
    val month: YearMonth = currentYearMonth(),
    val summary: MonthSummary = MonthSummary(currentYearMonth()),
    val recentTransactions: List<CashTransaction> = emptyList(),
    val projectNames: Map<String, String> = emptyMap(),
    val userName: String = "",
    /** The tenant's own company name; blank until set in Profil. */
    val companyName: String = "",
)

class DashboardViewModel(
    transactionRepository: TransactionRepository,
    projectRepository: ProjectRepository,
) : ViewModel() {

    val uiState: StateFlow<DashboardUiState> = combine(
        transactionRepository.transactions,
        projectRepository.projects,
        SessionManager.currentUser,
        CompanyProfile.name,
    ) { transactions, projects, user, companyName ->
        val month = currentYearMonth()
        DashboardUiState(
            month = month,
            summary = computeMonthSummary(transactions, month),
            recentTransactions = transactions.ledgerOnly().inMonth(month)
                .sortedByDescending { it.dateEpochMillis }
                .take(8),
            projectNames = projects.associate { it.id to it.name },
            userName = user?.name.orEmpty(),
            companyName = companyName,
        )
    }.stateIn(
        scope = viewModelScope,
        started = SharingStarted.WhileSubscribed(5_000),
        initialValue = DashboardUiState(userName = SessionManager.currentUser.value?.name.orEmpty()),
    )
}
